import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUsersActivity as getUsersActivityApi } from "../../helpers/realbackend_helper";

export const getActivityUsers = createAsyncThunk(
  "users/getActivity",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUsersActivityApi();
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
